<template>
  <div>
    <Form
      ref="form"
      :model="formData"
      :rules="config.rules"
      :disabled="isMethod(config.formBind && config.formBind.disabled)"
      v-bind="config.formBind"
      @submit.native.prevent=""
    >
      <Row :gutter="16">
        <Col
          :span="group.span ? group.span : 24"
          v-for="(group, groupIndex) in groupList"
          :key="groupIndex"
        >
          <template v-if="group.children">
            <div v-if="isMethod(group.show, {}, true)">
              <Card dis-hover style="margin-bottom: 20px">
                <div slot="title" v-if="group.render">
                  <ContentExpand
                    :render="group.render"
                    v-bind="group.bind"
                  ></ContentExpand>
                </div>
                <div slot="title" v-else>
                  {{ isMethod(group.name, { group, formData }) }}
                </div>
                <Row
                  v-for="(row, rowIndex) in group.children"
                  :key="rowIndex"
                  v-bind="config.rowBind"
                >
                  <Col
                    v-for="col in row"
                    :key="col.key"
                    :span="col.col"
                    v-bind="col.colBind || group.colBind || config.colBind"
                  >
                    <formItem
                      @clearFun="clearFun"
                      :col="col"
                      :fields="fields"
                      :formData="formData"
                    >
                      <template
                        #[col.solt]="{ visible, params, formData, close }"
                      >
                        <slot
                          :name="col.solt"
                          :field="col"
                          :visible="visible"
                          :params="params"
                          :formData="formData"
                          :close="close"
                        ></slot>
                      </template>
                    </formItem>
                  </Col>
                </Row>
              </Card>
            </div>
          </template>
          <div v-else>
            <Row v-bind="config.rowBind">
              <Col
                v-for="col in group"
                :key="col.key"
                :span="col.col"
                v-bind="col.colBind || config.colBind"
              >
                <formItem
                  @clearFun="clearFun"
                  :col="col"
                  :fields="fields"
                  :formData="formData"
                >
                  <template #[col.solt]="{ visible, params, close }">
                    <slot
                      :name="col.solt"
                      :field="col"
                      :visible="visible"
                      :params="params"
                      :close="close"
                    ></slot>
                  </template>
                </formItem>
              </Col>
            </Row>
          </div>
        </Col>

        <Col :span="24">
          <FormItem v-bind="config.buttons && config.buttons.bind">
            <template v-for="(btn, idx) in buttons">
              <Button
                style="margin-right: 20px"
                v-if="
                  isMethod(btn.show, { grid, btn, formData }, true) &&
                    $hasPermission(btn.id)
                "
                :key="idx"
                :type="btn.bind && btn.bind.type"
                v-bind="btn.bind"
                :disabled="isMethod(btn.disabled, { grid, btn, formData })"
                @click="click(btn, buttons)"
                >{{ isMethod(btn.name, { btn, formData }) }}</Button
              >
            </template>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
import formItem from "./form-item.vue";
import ContentExpand from "./expand";
import { isEmpty } from "@/libs/tools";
import { optionsApi, optionsCommonApi } from "@/libs/api.request.js";
import common from "../common.js";

export default {
  mixins: [common],

  components: {
    formItem,
    ContentExpand
  },
  inject: {
    $page: {
      default() {
        return this;
      }
    },
    $modal: {
      default: () => ({})
    }
  },
  provide() {
    return {
      $form: this
    };
  },
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    table: {
      type: Object,
      default: () => ({ fields: [] })
    },
    grid: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => ({})
    },
    buttons: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formData: {},
      orginFormData: {},
      rules: {},
      newGrid: []
    };
  },
  watch: {
    config: {
      immediate: true,
      handler(val) {
        if (val.rules) {
          Object.keys(val.rules).forEach(name => {
            val.rules[name].forEach(rule => {
              if (rule.validator) {
                rule.validator = rule.validator.bind(this);
                return;
              }
              this.fields.forEach(field => {
                if (field.key === name) {
                  if (
                    field.component === "Radio" ||
                    field.component === "Checkbox"
                  ) {
                    rule.message =
                      this.$t("select") + this.isMethod(field.name);
                  } else {
                    if (rule.max || rule.min) {
                      rule.message =
                        this.isMethod(field.name) +
                        this.$t("skuLength") +
                        (rule.min || 0) +
                        "-" +
                        (rule.max || 10);
                    } else {
                      rule.message = this.isMethod(field.placeholder);
                    }
                  }
                }
              });
            });
          });
        }
      }
    },
    fields: {
      immediate: true,
      handler(val) {
        val &&
          val.forEach(field => {
            if (field.methods) {
              if (field.methods.list)
                this.handleMethod({
                  methods: field.methods,
                  name: "list",
                  field
                });
              // if (field.methods["beforeUpload"]) {
              //   field.files = [];
              //   this.bindMethodThis(field.methods, "beforeUpload", { field });
              // }
            }
            this.$set(
              this.formData,
              field.key,
              this.isMethod(
                field.default,
                {
                  field,
                  formData: this.formData,
                  fields: val
                },
                ""
              )
            );
          });
      }
    },
    formData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit("updateFormData", val);
      }
    },
    groupList(val) {
      // console.log('new',val)
    }
  },
  mounted() {
    this.handleGridArr();
    optionsCommonApi(
      this.fields.reduce((a, b) => {
        b.optionsKey && a.set(b, b.optionsKey);
        return a;
      }, new Map())
    );
  },
  computed: {
    groupList() {
      return this.grid.reduce((a, b) => {
        let item = {};
        if (!this.isMethodDefault(b.show, {}, true)) return a;
        if (b.children) {
          let children = b.children.reduce((ca, cb) => {
            let citem = {};
            Object.keys(cb).forEach(key => {
              let item = this.filterFields.find(item => key === item.key);
              if (item) {
                item.col = cb[key];
                citem[key] = item;
              }
            });
            if (Object.keys(citem).length) ca.push(citem);
            return ca;
          }, []);
          a.push(Object.assign({}, b, { children: children }));
          // this.formData = newFormData;
        } else {
          let arr = [];
          Object.keys(b).forEach(key => {
            item = this.filterFields.find(item => key === item.key);
            if (item) {
              item.col = b[key];
              arr.push(item);
            }
          });
          if (arr.length) a.push(arr);
        }
        return a;
      }, []);
    },
    filterFields() {
      return this.fields.filter(field => {
        let show = this.isMethodDefault(
          field.show,
          {
            row: this.formData,
            field,
            value: this.formData && this.formData[field && field.key],
            formData: this.formData,
            fields: this.fields
          },
          true
        );
        if (show && field.optionsFn && !field.options.length) {
          optionsApi(field, field.optionsFn);
        }
        return show;
      });
    }
  },
  methods: {
    getRef(key) {
      return this.fields.find(t => t.key === key).ref;
    },
    async click(btn, buttons) {
      try {
        console.log("btn", this.formData);
        let result = {};
        if (btn.isSub) {
          result = await this.submit();
          console.log(result, "result");
        }

        this.handleMethod({
          methods: btn.methods,
          name: "click",
          fields: this.fields,
          formData: this.formData,
          grid: this.grid,
          buttons,
          result,
          btn
        });
      } catch (e) {
        //TODO handle the exception
        console.log(e);
      }
    },
    handleTree({ field, trees }) {
      // console.log(field, trees);
      let valKey = field.config ? field.config.value || "value" : "value";
      let treesInit = function(trees, value) {
        trees.forEach(item => {
          // item.selected = item.expand = false;
          if (!item.field) item.field = field;
          // if (~value.indexOf(item[valKey])) item.selected = true;
          if (item.children) treesInit(item.children, value);
        });
      };
      let handleValue = () => {
        let value = this.formData[field.key];
        if (typeof value === "object") {
          if (Array.isArray(value)) {
            let arr = [];
            if (typeof value[0] === "string") return value;
            value.forEach(item => {
              arr.push(item[valKey]);
            });
            return arr;
          } else {
            return [value[valKey]];
          }
        } else {
          return [value];
        }
      };
      let getOptions = function(trees, value, result) {
        trees.forEach(item => {
          if (value == item[valKey]) result.push(item);
          if (item.children) getOptions(item.children, value, result);
        });
      };
      setTimeout(() => {
        let value = handleValue();
        // console.log(value, "value");
        treesInit(trees, value);
        let options = [];
        getOptions(trees, value, options);
        field.options = options;
        field.trees = trees;
      }, 10);
    },
    bindMethodThis(method, name, params = {}) {
      if (typeof params !== "object") return console.log("参数必须是对象");
      if (method && method[name]) {
        if (!method["_" + name]) method["_" + name] = method[name];
        method[name] = method["_" + name].bind(this, {
          formData: this.formData,
          fields: this.fields,
          ...params
        });
      }
    },
    // handleFilterData(data) {
    //   let newFormData = {};
    //   return Object.assign({}, newFormData, data);
    // },
    handleFilterData(data) {
      let newFormData = {};
      this.filterFields.map(item => {
        if (item.methods && item.methods.format)
          newFormData[item.key] = this.$page.isMethod(item.methods.format, {
            value: this.formData[item.key],
            field: item,
            newFormData,
            formData: this.formData
          });
        else if (item.component === "DatePicker" && this.formData[item.key])
          newFormData[item.key] = this.$page.format.customTime(
            this.formData[item.key],
            item.format ||
              (item.bind && item.bind.type === "date"
                ? "YYYY-MM-DD"
                : "YYYY-MM-DD HH:mm:ss")
          );
        else newFormData[item.key] = this.formData[item.key];
      });
      return Object.assign({}, newFormData, data);
    },
    clear() {
      this.$refs["form"].resetFields();
      this.fields.forEach(field => {
        if (field.files) field.files = [];
        this.$set(
          this.formData,
          field.key,
          this.isMethod(field.default, {
            field,
            formData: this.formData,
            fields: this.fields
          })
        );
      });
    },
    clearFun(key) {
      if (isEmpty(this.formData[key])) {
        this.formData[key] = "";
      }
    },
    handleValidate(name) {
      console.log(this);
      // this.$refs["form"].validateField(name);
    },
    handleGridArr() {},
    handlePlaceholder(item, params) {
      let name = {
        Select: "select",
        DatePicker: "select"
      };
      return this.$page.isMethodDefault(
        item.placeholder,
        params,
        "Select " + item.key
      );
    },
    setFormData(data) {
      this.formData = data;
    },
    isMethodDefault(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return df;
    },
    isMethod(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return methods === undefined ? df : methods;
    },
    getProp(item, config, name) {
      return item[config ? config[name] || name : name];
    },
    handleMethod({ methods, name, row, field, btn, result }) {
      if (methods && methods[name])
        return methods[name].call(this, {
          row: this.formData,
          field,
          value: this.formData && this.formData[field && field.key],
          formData: this.formData,
          fields: this.fields,
          grid: this.grid,
          buttons: this.buttons,
          result,
          btn
        });
    },
    submit(deep) {
      // console.log(this.formData);
      return new Promise((res, rej) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            let newFormData = {};
            let fields = {};
            this.fields.map(item => {
              fields[item.key] = item;
              if (item.methods && item.methods.format)
                newFormData[item.key] = this.$page.isMethod(
                  item.methods.format,
                  {
                    value: this.formData[item.key],
                    field: item,
                    newFormData,
                    formData: this.formData
                  }
                );
              else if (
                item.component === "DatePicker" &&
                this.formData[item.key]
              )
                newFormData[item.key] = this.$page.format.timeFormat(
                  this.formData[item.key],
                  item.format
                );
              else newFormData[item.key] = this.formData[item.key];
            });
            let formData = { ...this.formData, ...newFormData };
            deep &&
              (formData = this.grid.reduce((a, b) => {
                if (b.children) {
                  if (!a[b.key] && b.key) a[b.key] = {};
                  b.children.forEach(c => {
                    Object.keys(c).forEach(k => {
                      if (fields[k].deep === false || !b.key)
                        return (a[k] = formData[k]);
                      a[b.key][k] = formData[k];
                    });
                  });
                } else {
                  Object.keys(b).forEach(k => {
                    a[k] = formData[k];
                  });
                }
                return a;
              }, {}));
            res(formData);
          } else {
            // this.$Message.error('请完善表单');
            rej(new Error("请完善表单"));
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.flex-center {
  display: flex;
  align-items: center;
  height: 100%;
}

.ivu-form-item {
  margin-bottom: 0;
  margin-right: 0px;
}
</style>
